// @ts-nocheck
/**
 * Does the same thing than scrollToId (from the toolkit), but you can pass a height that will adjust the scoll value
 */
const adjustableScrollToId = (id: string, height: number | null, smooth?: boolean) => {
    const idToScrollTo = document.getElementById(id);
    const viewportPosition = idToScrollTo?.getBoundingClientRect().top || 0;
    const viewportToDocument = window.scrollY;
    const heightValue = height || 0;
    const scrollTopPx = viewportPosition + viewportToDocument - heightValue;
    const scrollBehavior = smooth ? "smooth" : "auto";

    document.body.scrollTop = scrollTopPx; // Safari
    document.documentElement.scrollTo({
        top: scrollTopPx,
        behavior: scrollBehavior,
    }); // Chrome, Firefox, IE and Opera

    idToScrollTo?.focus();
};

export default adjustableScrollToId;
